
import superagent from "superagent";
import {authorize} from "../../helper/authorize-token";
import {deep_copy, string_cmp} from "../../../lib/js-utils";

const LOAD_ONBOARDING_RUNS = "LOAD_ONBOARDING_RUNS";
const SET_TEST_LOADING = "SET_TEST_LOADING";

const INIT_STATE = {
  loading: false,
  groups: [], // { name: string, runs: any[] }
};

const loadOnboardingRuns = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SET_TEST_LOADING,
      value: true,
    })
    dispatch({
      type: LOAD_ONBOARDING_RUNS,
      payload: superagent
        .post("/api/dashboard/e2e-test-runs")
        .use(authorize(getState()))
        .send({
          name: "onboarding",
          num: 20,
        })
    })
  }
}

const loadOnboardingRun = (token, path, index) => {
  return new Promise(resolve => {
    superagent.agent()
      .post("/api/dashboard/e2e-test-runs")
      .use(authorize(token))
      .send({ path, index})
      .then(res => {
        return resolve(res.body);
      })
  })
}



const testReducer = (state = INIT_STATE, action) => {

  let new_state = deep_copy(state);

  switch(action.type) {
    case SET_TEST_LOADING:
      new_state.loading = action.value;
      return new_state;
    case LOAD_ONBOARDING_RUNS + "_FULFILLED":
      const resp = action.payload.body;
      if (resp.status === "ERROR") {
        break;
      }

      new_state.groups = new_state.groups.filter(item => item.name !== resp.payload.name);
      new_state.groups.push(resp.payload);
      new_state.groups.sort((a, b) => string_cmp(a.name, b.name));
      new_state.loading = false;
      return new_state;
    default:
      return new_state;
  }
}

export { testReducer, loadOnboardingRuns, loadOnboardingRun };
